import { api } from '../api'

import type { ApiTableAddBot } from '@acepoker/contract'

export const addBot = async (data: ApiTableAddBot): Promise<{ code: number }> =>
  await api().url('/api/table/bot').post(data).json()
